import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const affirmationProgramEntitlementImporterSelectors = importerSelectors(
  'affirmationProgramEntitlement.importer',
);

export default affirmationProgramEntitlementImporterSelectors;
